var t = Object.freeze({
  __proto__: null,

  get start() {
    return Wt;
  },

  get ensureJQuerySupport() {
    return bt;
  },

  get setBootstrapMaxTime() {
    return G;
  },

  get setMountMaxTime() {
    return q;
  },

  get setUnmountMaxTime() {
    return k;
  },

  get setUnloadMaxTime() {
    return W;
  },

  get registerApplication() {
    return xt;
  },

  get getMountedApps() {
    return Nt;
  },

  get getAppStatus() {
    return _t;
  },

  get unloadApplication() {
    return Lt;
  },

  get checkActivityFunctions() {
    return Ut;
  },

  get getAppNames() {
    return jt;
  },

  get declareChildApplication() {
    return Dt;
  },

  get unloadChildApplication() {
    return Rt;
  },

  get navigateToUrl() {
    return ft;
  },

  get triggerAppChange() {
    return Gt;
  },

  get addErrorHandler() {
    return h;
  },

  get removeErrorHandler() {
    return d;
  },

  get mountRootParcel() {
    return et;
  },

  get NOT_LOADED() {
    return g;
  },

  get LOADING_SOURCE_CODE() {
    return w;
  },

  get NOT_BOOTSTRAPPED() {
    return y;
  },

  get BOOTSTRAPPING() {
    return b;
  },

  get NOT_MOUNTED() {
    return E;
  },

  get MOUNTING() {
    return O;
  },

  get UPDATING() {
    return T;
  },

  get LOAD_ERROR() {
    return N;
  },

  get MOUNTED() {
    return P;
  },

  get UNMOUNTING() {
    return A;
  },

  get SKIP_BECAUSE_BROKEN() {
    return j;
  }

}),
    n = ("undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {}).CustomEvent;
var e = function () {
  try {
    var t = new n("cat", {
      detail: {
        foo: "bar"
      }
    });
    return "cat" === t.type && "bar" === t.detail.foo;
  } catch (t) {}

  return !1;
}() ? n : "undefined" != typeof document && "function" == typeof document.createEvent ? function (t, n) {
  var e = document.createEvent("CustomEvent");
  return n ? e.initCustomEvent(t, n.bubbles, n.cancelable, n.detail) : e.initCustomEvent(t, !1, !1, void 0), e;
} : function (t, n) {
  var e = document.createEventObject();
  return e.type = t, n ? (e.bubbles = Boolean(n.bubbles), e.cancelable = Boolean(n.cancelable), e.detail = n.detail) : (e.bubbles = !1, e.cancelable = !1, e.detail = void 0), e;
};

function r(t) {
  return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(t);
}

function o(t, n, e) {
  return n in t ? Object.defineProperty(t, n, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = e, t;
}

function i(t, n) {
  var e = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    n && (r = r.filter(function (n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), e.push.apply(e, r);
  }

  return e;
}

function u(t) {
  for (var n = 1; n < arguments.length; n++) {
    var e = null != arguments[n] ? arguments[n] : {};
    n % 2 ? i(e, !0).forEach(function (n) {
      o(t, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : i(e).forEach(function (n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }

  return t;
}

function a(t) {
  return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function c(t, n) {
  return (c = Object.setPrototypeOf || function (t, n) {
    return t.__proto__ = n, t;
  })(t, n);
}

function s(t, n, e) {
  return (s = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }() ? Reflect.construct : function (t, n, e) {
    var r = [null];
    r.push.apply(r, n);
    var o = new (Function.bind.apply(t, r))();
    return e && c(o, e.prototype), o;
  }).apply(null, arguments);
}

function f(t) {
  var n = "function" == typeof Map ? new Map() : void 0;
  return (f = function f(t) {
    if (null === t || (e = t, -1 === Function.toString.call(e).indexOf("[native code]"))) return t;
    var e;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== n) {
      if (n.has(t)) return n.get(t);
      n.set(t, r);
    }

    function r() {
      return s(t, arguments, a(this).constructor);
    }

    return r.prototype = Object.create(t.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), c(r, t);
  })(t);
}

function l(t, n) {
  return !n || "object" != typeof n && "function" != typeof n ? function (t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }(t) : n;
}

var p = [];

function m(t, n) {
  var e = v(t, n);
  p.length ? p.forEach(function (t) {
    return t(e);
  }) : setTimeout(function () {
    throw e;
  });
}

function h(t) {
  if ("function" != typeof t) throw Error("a single-spa error handler must be a function");
  p.push(t);
}

function d(t) {
  if ("function" != typeof t) throw Error("a single-spa error handler must be a function");
  var n = !1;
  return p = p.filter(function (e) {
    var r = e === t;
    return n = n || r, !r;
  }), n;
}

function v(t, n) {
  var e,
      r = n.unmountThisParcel ? "Parcel" : "Application",
      o = "".concat(r, " '").concat(n.name, "' died in status ").concat(n.status, ": ");

  if (t instanceof Error) {
    try {
      t.message = o + t.message;
    } catch (t) {}

    e = t;
  } else {
    console.warn("While ".concat(n.status, ", '").concat(n.name, "' rejected its lifecycle function promise with a non-Error. This will cause stack traces to not be accurate."));

    try {
      e = Error(o + JSON.stringify(t));
    } catch (n) {
      e = t;
    }
  }

  e.appName = n.name, e.appOrParcelName = n.name;

  try {
    e.name = n.name;
  } catch (t) {}

  return e;
}

var g = "NOT_LOADED",
    w = "LOADING_SOURCE_CODE",
    y = "NOT_BOOTSTRAPPED",
    b = "BOOTSTRAPPING",
    E = "NOT_MOUNTED",
    O = "MOUNTING",
    P = "MOUNTED",
    T = "UPDATING",
    A = "UNMOUNTING",
    S = "UNLOADING",
    N = "LOAD_ERROR",
    j = "SKIP_BECAUSE_BROKEN";

function _(t) {
  return t.status === P;
}

function D(t) {
  return !_(t);
}

function x(t) {
  return t.status !== g && t.status !== w && t.status !== N;
}

function U(t) {
  return !x(t);
}

function C(t) {
  try {
    return t.activeWhen(window.location);
  } catch (n) {
    m(n, t), t.status = j;
  }
}

function R(t) {
  try {
    return !t.activeWhen(window.location);
  } catch (n) {
    m(n, t), t.status = j;
  }
}

function L(t) {
  return t !== j && (!t || t.status !== j);
}

function I(t) {
  return t.status !== N || new Date().getTime() - t.loadErrorTime >= 200;
}

function M(t) {
  return t.name;
}

var B = {
  bootstrap: {
    millis: 4e3,
    dieOnTimeout: !1
  },
  mount: {
    millis: 3e3,
    dieOnTimeout: !1
  },
  unmount: {
    millis: 3e3,
    dieOnTimeout: !1
  },
  unload: {
    millis: 3e3,
    dieOnTimeout: !1
  }
};

function G(t) {
  var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  if ("number" != typeof t || t <= 0) throw Error("bootstrap max time must be a positive integer number of milliseconds");
  B.bootstrap = {
    millis: t,
    dieOnTimeout: n
  };
}

function q(t) {
  var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  if ("number" != typeof t || t <= 0) throw Error("mount max time must be a positive integer number of milliseconds");
  B.mount = {
    millis: t,
    dieOnTimeout: n
  };
}

function k(t) {
  var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  if ("number" != typeof t || t <= 0) throw Error("unmount max time must be a positive integer number of milliseconds");
  B.unmount = {
    millis: t,
    dieOnTimeout: n
  };
}

function W(t) {
  var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  if ("number" != typeof t || t <= 0) throw Error("unload max time must be a positive integer number of milliseconds");
  B.unload = {
    millis: t,
    dieOnTimeout: n
  };
}

function F(t, n, e) {
  var r = 1e3;
  return new Promise(function (o, i) {
    var u = !1,
        a = !1;

    function c(t) {
      if (!u) if (!0 === t) a = !0, e.dieOnTimeout ? i("".concat(n, " did not resolve or reject for ").concat(e.millis, " milliseconds")) : console.error("".concat(n, " did not resolve or reject for ").concat(e.millis, " milliseconds -- we're no longer going to warn you about it."));else if (!a) {
        var o = t,
            s = o * r;
        console.warn("".concat(n, " did not resolve or reject within ").concat(s, " milliseconds")), s + r < e.millis && setTimeout(function () {
          return c(o + 1);
        }, r);
      }
    }

    t.then(function (t) {
      u = !0, o(t);
    }).catch(function (t) {
      u = !0, i(t);
    }), setTimeout(function () {
      return c(1);
    }, r), setTimeout(function () {
      return c(!0);
    }, e.millis);
  });
}

function K() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return u({}, B, {}, t);
}

function $(t, n) {
  for (var e = 0; e < t.length; e++) {
    if (n(t[e])) return t[e];
  }

  return null;
}

function H(t) {
  return t && ("function" == typeof t || (n = t, Array.isArray(n) && !$(n, function (t) {
    return "function" != typeof t;
  })));
  var n;
}

function J(t, n) {
  return 0 === (t = Array.isArray(t) ? t : [t]).length && (t = [function () {
    return Promise.resolve();
  }]), function (e) {
    return new Promise(function (r, o) {
      !function i(u) {
        var a = t[u](e);
        Q(a) ? a.then(function () {
          u === t.length - 1 ? r() : i(u + 1);
        }).catch(o) : o("".concat(n, " at index ").concat(u, " did not return a promise"));
      }(0);
    });
  };
}

function Q(t) {
  return t && "function" == typeof t.then && "function" == typeof t.catch;
}

function V(t) {
  var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  return Promise.resolve().then(function () {
    return t.status !== y ? t : (t.status = b, F(t.bootstrap(it(t)), "Bootstrapping appOrParcel '".concat(t.name, "'"), t.timeouts.bootstrap).then(function () {
      return t.status = E, t;
    }).catch(function (e) {
      if (t.status = j, n) throw v(e, t);
      return m(e, t), t;
    }));
  });
}

function z(t) {
  var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  return Promise.resolve().then(function () {
    if (t.status !== P) return t;
    t.status = A;
    var e = Object.keys(t.parcels).map(function (n) {
      return t.parcels[n].unmountThisParcel();
    });
    return Promise.all(e).then(r, function (e) {
      return r().then(function () {
        var r = Error(e.message);

        if (n) {
          var o = v(r, t);
          throw t.status = j, o;
        }

        m(r, t), t.status = j;
      });
    }).then(function () {
      return t;
    });

    function r() {
      return F(t.unmount(it(t)), "Unmounting application ".concat(t.name, "'"), t.timeouts.unmount).then(function () {
        t.status = E;
      }).catch(function (e) {
        if (n) {
          var r = v(e, t);
          throw t.status = j, r;
        }

        m(e, t), t.status = j;
      });
    }
  });
}

var X = !1,
    Y = !1;

function Z(t) {
  var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  return Promise.resolve().then(function () {
    return t.status !== E ? t : (X || (window.dispatchEvent(new e("single-spa:before-first-mount")), X = !0), F(t.mount(it(t)), "Mounting application '".concat(t.name, "'"), t.timeouts.mount).then(function () {
      return t.status = P, Y || (window.dispatchEvent(new e("single-spa:first-mount")), Y = !0), t;
    }).catch(function (e) {
      return t.status = P, z(t).then(r, r);

      function r() {
        if (n) {
          var r = v(e, t);
          throw t.status = j, r;
        }

        return m(e, t), t.status = j, t;
      }
    }));
  });
}

var tt = 0,
    nt = {
  parcels: {}
};

function et() {
  return rt.apply(nt, arguments);
}

function rt(t, n) {
  var e = this;
  if (!t || "object" !== r(t) && "function" != typeof t) throw Error("Cannot mount parcel without a config object or config loading function");
  if (t.name && "string" != typeof t.name) throw Error("Parcel name must be a string, if provided");
  if ("object" !== r(n)) throw Error("Parcel ".concat(name, " has invalid customProps -- must be an object"));
  if (!n.domElement) throw Error("Parcel ".concat(name, " cannot be mounted without a domElement provided as a prop"));
  var o,
      i = tt++,
      u = "function" == typeof t,
      a = u ? t : function () {
    return Promise.resolve(t);
  },
      c = {
    id: i,
    parcels: {},
    status: u ? w : y,
    customProps: n,
    parentName: e.name,
    unmountThisParcel: function unmountThisParcel() {
      if (c.status !== P) throw Error("Cannot unmount parcel '".concat(name, "' -- it is in a ").concat(c.status, " status"));
      return z(c, !0).then(function (t) {
        return c.parentName && delete e.parcels[c.id], t;
      }).then(function (t) {
        return f(t), t;
      }).catch(function (t) {
        throw c.status = j, l(t), t;
      });
    }
  };
  e.parcels[i] = c;
  var s = a();
  if (!s || "function" != typeof s.then) throw Error("When mounting a parcel, the config loading function must return a promise that resolves with the parcel config");
  var f,
      l,
      p = (s = s.then(function (t) {
    if (!t) throw Error("When mounting a parcel, the config loading function returned a promise that did not resolve with a parcel config");
    var n = t.name || "parcel-".concat(i);
    if (!H(t.bootstrap)) throw Error("Parcel ".concat(n, " must have a valid bootstrap function"));
    if (!H(t.mount)) throw Error("Parcel ".concat(n, " must have a valid mount function"));
    if (!H(t.unmount)) throw Error("Parcel ".concat(n, " must have a valid unmount function"));
    if (t.update && !H(t.update)) throw Error("Parcel ".concat(n, " provided an invalid update function"));
    var e = J(t.bootstrap),
        r = J(t.mount),
        u = J(t.unmount);
    c.status = y, c.name = n, c.bootstrap = e, c.mount = r, c.unmount = u, c.timeouts = K(t.timeouts), t.update && (c.update = J(t.update), o.update = function (t) {
      return c.customProps = t, ot(function (t) {
        return Promise.resolve().then(function () {
          if (t.status !== P) throw Error("Cannot update parcel '".concat(t.name, "' because it is not mounted"));
          return t.status = T, F(t.update(it(t)), "Updating parcel '".concat(t.name, "'"), t.timeouts.mount).then(function () {
            return t.status = P, t;
          }).catch(function (n) {
            var e = v(n, t);
            throw t.status = j, e;
          });
        });
      }(c));
    });
  })).then(function () {
    return V(c, !0);
  }),
      m = p.then(function () {
    return Z(c, !0);
  }),
      h = new Promise(function (t, n) {
    f = t, l = n;
  });
  return o = {
    mount: function mount() {
      return ot(Promise.resolve().then(function () {
        if (c.status !== E) throw Error("Cannot mount parcel '".concat(name, "' -- it is in a ").concat(c.status, " status"));
        return e.parcels[i] = c, Z(c);
      }));
    },
    unmount: function unmount() {
      return ot(c.unmountThisParcel());
    },
    getStatus: function getStatus() {
      return c.status;
    },
    loadPromise: ot(s),
    bootstrapPromise: ot(p),
    mountPromise: ot(m),
    unmountPromise: ot(h)
  };
}

function ot(t) {
  return t.then(function () {
    return null;
  });
}

function it(n) {
  var e = u({}, n.customProps, {
    name: n.name,
    mountParcel: rt.bind(n),
    singleSpa: t
  });
  return n.unmountThisParcel && (e.unmountSelf = n.unmountThisParcel), e;
}

var ut = function (t) {
  function n() {
    return function (t, n) {
      if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
    }(this, n), l(this, a(n).apply(this, arguments));
  }

  return function (t, n) {
    if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(n && n.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), n && c(t, n);
  }(n, f(Error)), n;
}();

function at(t) {
  return Promise.resolve().then(function () {
    return t.status !== g && t.status !== N ? t : (t.status = w, Promise.resolve().then(function () {
      var e = t.loadImpl(it(t));
      if (!Q(e)) throw new ut("single-spa loading function did not return a promise. Check the second argument to registerApplication('".concat(t.name, "', loadingFunction, activityFunction)"));
      return e.then(function (e) {
        var o;
        return t.loadErrorTime = null, "object" !== r(n = e) && (o = "does not export anything"), H(n.bootstrap) || (o = "does not export a bootstrap function or array of functions"), H(n.mount) || (o = "does not export a mount function or array of functions"), H(n.unmount) || (o = "does not export an unmount function or array of functions"), o ? (console.error("The loading function for single-spa application '".concat(t.name, "' resolved with the following, which does not have bootstrap, mount, and unmount functions"), n), m(o, t), t.status = j, t) : (n.devtools && n.devtools.overlays && (t.devtools.overlays = u({}, t.devtools.overlays, {}, n.devtools.overlays)), t.status = y, t.bootstrap = J(n.bootstrap, "App '".concat(t.name, "' bootstrap function")), t.mount = J(n.mount, "App '".concat(t.name, "' mount function")), t.unmount = J(n.unmount, "App '".concat(t.name, "' unmount function")), t.unload = J(n.unload || [], "App '".concat(t.name, "' unload function")), t.timeouts = K(n.timeouts), t);
      });
    }).catch(function (n) {
      return m(n, t), n instanceof ut ? t.status = j : (t.status = N, t.loadErrorTime = new Date().getTime()), t;
    }));
    var n;
  });
}

var ct = {
  hashchange: [],
  popstate: []
},
    st = ["hashchange", "popstate"];

function ft(t) {
  var n,
      e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  if ("string" == typeof t) n = t;else if (this && this.href) n = this.href;else {
    if (!(t && t.currentTarget && t.currentTarget.href && t.preventDefault)) throw Error("singleSpaNavigate must be either called with a string url, with an <a> tag as its context, or with an event whose currentTarget is an <a> tag");
    n = t.currentTarget.href, t.preventDefault();
  }
  var r = wt(window.location.href),
      o = wt(n);
  if (0 === n.indexOf("#")) window.location.hash = "#" + o.anchor;else if (r.host !== o.host && o.host) {
    if (e.isTestingEnv) return {
      wouldHaveReloadedThePage: !0
    };
    window.location.href = n;
  } else !function (t, n) {
    return n === t || n === "/" + t;
  }(o.path + "?" + o.query, r.path + "?" + r.query) ? window.history.pushState(null, null, n) : window.location.hash = "#" + o.anchor;
}

function lt(t) {
  var n = this;

  if (t) {
    var e = t[0].type;
    st.indexOf(e) >= 0 && ct[e].forEach(function (e) {
      e.apply(n, t);
    });
  }
}

function pt() {
  qt([], arguments);
}

window.addEventListener("hashchange", pt), window.addEventListener("popstate", pt);
var mt = window.addEventListener,
    ht = window.removeEventListener;
window.addEventListener = function (t, n) {
  if (!("function" == typeof n && st.indexOf(t) >= 0) || $(ct[t], function (t) {
    return t === n;
  })) return mt.apply(this, arguments);
  ct[t].push(n);
}, window.removeEventListener = function (t, n) {
  if (!("function" == typeof n && st.indexOf(t) >= 0)) return ht.apply(this, arguments);
  ct[t] = ct[t].filter(function (t) {
    return t !== n;
  });
};
var dt = window.history.pushState;

window.history.pushState = function (t) {
  var n = dt.apply(this, arguments);
  return pt(gt(t)), n;
};

var vt = window.history.replaceState;

function gt(t) {
  try {
    return new PopStateEvent("popstate", {
      state: t
    });
  } catch (e) {
    var n = document.createEvent("PopStateEvent");
    return n.initPopStateEvent("popstate", !1, !1, t), n;
  }
}

function wt(t) {
  for (var n = {
    strictMode: !0,
    key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
    q: {
      name: "queryKey",
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
    },
    parser: {
      strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
    }
  }, e = n.parser.strict.exec(t), r = {}, o = 14; o--;) {
    r[n.key[o]] = e[o] || "";
  }

  return r[n.q.name] = {}, r[n.key[12]].replace(n.q.parser, function (t, e, o) {
    e && (r[n.q.name][e] = o);
  }), r;
}

window.history.replaceState = function (t) {
  var n = vt.apply(this, arguments);
  return pt(gt(t)), n;
}, window.singleSpaNavigate = ft;
var yt = !1;

function bt() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.jQuery;

  if (t || window.$ && window.$.fn && window.$.fn.jquery && (t = window.$), t && !yt) {
    var n = t.fn.on,
        e = t.fn.off;
    t.fn.on = function (t, e) {
      return Et.call(this, n, window.addEventListener, t, e, arguments);
    }, t.fn.off = function (t, n) {
      return Et.call(this, e, window.removeEventListener, t, n, arguments);
    }, yt = !0;
  }
}

function Et(t, n, e, r, o) {
  return "string" != typeof e ? t.apply(this, o) : (e.split(/\s+/).forEach(function (t) {
    st.indexOf(t) >= 0 && (n(t, r), e = e.replace(t, ""));
  }), "" === e.trim() ? this : t.apply(this, o));
}

var Ot = {};

function Pt(t) {
  return Promise.resolve().then(function () {
    var n = Ot[t.name];
    return n ? t.status === g ? (Tt(t, n), t) : t.status === S ? n.promise.then(function () {
      return t;
    }) : t.status !== E ? t : (t.status = S, F(t.unload(it(t)), "Unloading application '".concat(t.name, "'"), t.timeouts.unload).then(function () {
      return Tt(t, n), t;
    }).catch(function (e) {
      return function (t, n, e) {
        delete Ot[t.name], delete t.bootstrap, delete t.mount, delete t.unmount, delete t.unload, m(e, t), t.status = j, n.reject(e);
      }(t, n, e), t;
    })) : t;
  });
}

function Tt(t, n) {
  delete Ot[t.name], delete t.bootstrap, delete t.mount, delete t.unmount, delete t.unload, t.status = g, n.resolve();
}

function At(t, n, e, r) {
  Ot[t.name] = {
    app: t,
    resolve: e,
    reject: r
  }, Object.defineProperty(Ot[t.name], "promise", {
    get: n
  });
}

var St = [];

function Nt() {
  return St.filter(_).map(M);
}

function jt() {
  return St.map(M);
}

function _t(t) {
  var n = $(St, function (n) {
    return n.name === t;
  });
  return n ? n.status : null;
}

function Dt(t, n, e) {
  return console.warn('declareChildApplication is deprecated and will be removed in the next major version, use "registerApplication" instead'), xt(t, n, e);
}

function xt(t, n, e) {
  var o,
      i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
  if ("string" != typeof t || 0 === t.length) throw Error("The first argument must be a non-empty string 'appName'");
  if (-1 !== jt().indexOf(t)) throw Error("There is already an app declared with name ".concat(t));
  if ("object" !== r(i) || Array.isArray(i)) throw Error("customProps must be an object");
  if (!n) throw Error("The application or loading function is required");
  if (o = "function" != typeof n ? function () {
    return Promise.resolve(n);
  } : n, "function" != typeof e) throw Error("The activeWhen argument must be a function");
  St.push({
    loadErrorTime: null,
    name: t,
    loadImpl: o,
    activeWhen: e,
    status: g,
    parcels: {},
    devtools: {
      overlays: {
        options: {},
        selectors: []
      }
    },
    customProps: i
  }), bt(), qt();
}

function Ut(t) {
  for (var n = [], e = 0; e < St.length; e++) {
    St[e].activeWhen(t) && n.push(St[e].name);
  }

  return n;
}

function Ct() {
  return St.filter(L).filter(I).filter(U).filter(C);
}

function Rt(t, n) {
  return console.warn('unloadChildApplication is deprecated and will be removed in the next major version, use "unloadApplication" instead'), Lt(t, n);
}

function Lt(t) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
    waitForUnmount: !1
  };
  if ("string" != typeof t) throw Error("unloadApplication requires a string 'appName'");
  var e = $(St, function (n) {
    return n.name === t;
  });
  if (!e) throw Error("Could not unload application '".concat(t, "' because no such application has been registered"));

  var r,
      o = function (t) {
    return Ot[t];
  }(e.name);

  if (n && n.waitForUnmount) {
    if (o) return o.promise;
    var i = new Promise(function (t, n) {
      At(e, function () {
        return i;
      }, t, n);
    });
    return i;
  }

  return o ? (r = o.promise, It(e, o.resolve, o.reject)) : r = new Promise(function (t, n) {
    At(e, function () {
      return r;
    }, t, n), It(e, t, n);
  }), r;
}

function It(t, n, e) {
  z(t).then(Pt).then(function () {
    n(), setTimeout(function () {
      qt();
    });
  }).catch(e);
}

var Mt = !1,
    Bt = [];

function Gt() {
  return qt();
}

function qt() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
      n = arguments.length > 1 ? arguments[1] : void 0;
  if (Mt) return new Promise(function (t, e) {
    Bt.push({
      resolve: t,
      reject: e,
      eventArguments: n
    });
  });
  Mt = !0;
  var r = !0;
  return kt ? Promise.resolve().then(function () {
    window.dispatchEvent(new e("single-spa:before-routing-event", u()));
    var n = Object.keys(Ot).map(function (t) {
      return Ot[t].app;
    }).filter(D).map(Pt),
        a = St.filter(L).filter(_).filter(R).map(z).map(function (t) {
      return t.then(Pt);
    }).concat(n);
    a.length > 0 && (r = !1);
    var c = Promise.all(a),
        s = Ct(),
        f = s.map(function (t) {
      return at(t).then(V).then(function (t) {
        return c.then(function () {
          return Z(t);
        });
      });
    });
    f.length > 0 && (r = !1);
    var l = St.filter(L).filter(D).filter(x).filter(C).filter(function (t) {
      return s.indexOf(t) < 0;
    }).map(function (t) {
      return V(t).then(function () {
        return c;
      }).then(function () {
        return Z(t);
      });
    });
    return l.length > 0 && (r = !1), c.catch(function (t) {
      throw i(), t;
    }).then(function () {
      return i(), Promise.all(f.concat(l)).catch(function (n) {
        throw t.forEach(function (t) {
          return t.reject(n);
        }), n;
      }).then(function () {
        return o(!1);
      });
    });
  }) : Promise.resolve().then(function () {
    var t = Ct().map(at);
    return t.length > 0 && (r = !1), Promise.all(t).then(o).catch(function (t) {
      throw i(), t;
    });
  });

  function o() {
    var n = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
        o = Nt();
    n && i(), t.forEach(function (t) {
      return t.resolve(o);
    });

    try {
      var a = r ? "single-spa:no-app-change" : "single-spa:app-change";
      window.dispatchEvent(new e(a, u())), window.dispatchEvent(new e("single-spa:routing-event", u()));
    } catch (t) {
      setTimeout(function () {
        throw t;
      });
    }

    if (Mt = !1, Bt.length > 0) {
      var c = Bt;
      Bt = [], qt(c);
    }

    return o;
  }

  function i() {
    t.forEach(function (t) {
      lt(t.eventArguments);
    }), lt(n);
  }

  function u() {
    var t = {
      detail: {}
    };
    return n && n[0] && (t.detail.originalEvent = n[0]), t;
  }
}

var kt = !1;

function Wt() {
  kt = !0, qt();
}

setTimeout(function () {
  kt || console.warn("singleSpa.start() has not been called, ".concat(5e3, "ms after single-spa was loaded. Before start() is called, apps can be declared and loaded, but not bootstrapped or mounted. See https://github.com/CanopyTax/single-spa/blob/master/docs/single-spa-api.md#start"));
}, 5e3);
var Ft = {
  getRawAppData: function getRawAppData() {
    return [].concat(St);
  },
  reroute: qt,
  NOT_LOADED: g,
  toLoadPromise: at,
  toBootstrapPromise: V,
  unregisterApplication: function unregisterApplication(t) {
    if (!St.find(function (n) {
      return n.name === t;
    })) throw Error("Cannot unregister application '".concat(t, "' because no such application has been registered"));
    return Lt(t).then(function () {
      var n = St.findIndex(function (n) {
        return n.name === t;
      });
      St.splice(n, 1);
    });
  }
};
window && window.__SINGLE_SPA_DEVTOOLS__ && (window.__SINGLE_SPA_DEVTOOLS__.exposedMethods = Ft);
export { b as BOOTSTRAPPING, w as LOADING_SOURCE_CODE, N as LOAD_ERROR, P as MOUNTED, O as MOUNTING, y as NOT_BOOTSTRAPPED, g as NOT_LOADED, E as NOT_MOUNTED, j as SKIP_BECAUSE_BROKEN, A as UNMOUNTING, T as UPDATING, h as addErrorHandler, Ut as checkActivityFunctions, Dt as declareChildApplication, bt as ensureJQuerySupport, jt as getAppNames, _t as getAppStatus, Nt as getMountedApps, et as mountRootParcel, ft as navigateToUrl, xt as registerApplication, d as removeErrorHandler, G as setBootstrapMaxTime, q as setMountMaxTime, W as setUnloadMaxTime, k as setUnmountMaxTime, Wt as start, Gt as triggerAppChange, Lt as unloadApplication, Rt as unloadChildApplication };